var _circle, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgParisTransitIconsMtro7(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "250px",
    height: "250px",
    viewBox: "0 0 283.46 283.46",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Paris transit icons - M\xE9tro Ligne 7") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    fill: "#F3A4BA",
    cx: 141.73,
    cy: 141.73,
    r: 141.73
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#25303B",
    d: "M196.17 91.25V66.77H91.05v25.12h73L127.44 160c-13.19 24.46-18.51 37.23-18.51 57h34.26c0-23.61 20-68.53 53-125.75"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgParisTransitIconsMtro7);
export default __webpack_public_path__ + "static/media/Paris_transit_icons_-_Métro_7.13baea72dfa03f31c6b1a7dd36b6206a.svg";
export { ForwardRef as ReactComponent };